import React, { Component } from "react";
import moment from "moment";
import redux from "../common/Redux";
import Modal from "./Modal";
class LanguageSelection extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    // if (!this.props.langSelectorOpen) return null;
    return (
      <Modal
        visible={this.props.langSelectorOpen}
        title="Select Language"
        onClose={() => this.props.setLangSelectorOpen(false)}
      >
        <div>
          {[
            { tag: "mr", label: "Marathi" },
            { tag: "hi", label: "Hindi" },
            { tag: "en", label: "English" },
            { tag: "gj", label: "Gujrati" },
          ].map((item, index) => {
            return (
              <div
                key={index}
                style={{
                  padding: "10px",
                  margin: "10px",
                  backgroundColor: "black",
                  borderRadius: "3px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  this.props.setLangSelectorOpen(false);
                  this.props.setLanguage(item.tag);
                }}
              >
                {item.label}
              </div>
            );
          })}
        </div>
      </Modal>
    );
  }
}

export default redux(LanguageSelection);
